'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toArrayQuery = toArrayQuery;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getContext = require('recompose/getContext');

var _getContext2 = _interopRequireDefault(_getContext);

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _injectProps = require('recompose-scope/injectProps');

var _injectProps2 = _interopRequireDefault(_injectProps);

var _exposeHandlers = require('recompose-scope/exposeHandlers');

var _exposeHandlers2 = _interopRequireDefault(_exposeHandlers);

var _exposeNamespace = require('recompose-scope/exposeNamespace');

var _exposeNamespace2 = _interopRequireDefault(_exposeNamespace);

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

var _omitBy = require('lodash/fp/omitBy');

var _omitBy2 = _interopRequireDefault(_omitBy);

var _isNil = require('coact-utils/isNil');

var _isNil2 = _interopRequireDefault(_isNil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var API_PREFIX = '/api/model';

function toArrayQuery(oriQuery) {
  var query = {};
  Object.keys(oriQuery).forEach(function (key) {
    var index = key.indexOf('.0.');
    if (index > -1) {
      var keyHead = key.substring(0, index);
      var keyTail = key.substring(index + 3);
      if (!query[keyHead]) query[keyHead] = { $elemMatch: {} };
      query[keyHead].$elemMatch[keyTail] = oriQuery[key];
    } else {
      query[key] = oriQuery[key];
    }
  });
  return query;
}

var findDoc = function findDoc(_ref) {
  var server = _ref.server,
      _ref$page = _ref.page,
      view = _ref$page.view,
      docId = _ref$page.docId;
  return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
    var _ref3, doc;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return server.get({
              url: [API_PREFIX, view, docId].join('/')
            });

          case 2:
            _ref3 = _context.sent;
            doc = _ref3.data;
            return _context.abrupt('return', doc);

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));
};
var insertDoc = function insertDoc(_ref4) {
  var server = _ref4.server,
      view = _ref4.page.view;
  return function () {
    var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(data) {
      var _ref6, doc;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return server.post({
                url: [API_PREFIX, view].join('/'),
                data: data
              });

            case 2:
              _ref6 = _context2.sent;
              doc = _ref6.data;
              return _context2.abrupt('return', doc);

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, undefined);
    }));

    return function (_x) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var updateDoc = function updateDoc(_ref7) {
  var server = _ref7.server,
      _ref7$page = _ref7.page,
      view = _ref7$page.view,
      docId = _ref7$page.docId;
  return function () {
    var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(data) {
      var _ref9, doc;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return server.patch({
                url: [API_PREFIX, view, docId].join('/'),
                data: data
              });

            case 2:
              _ref9 = _context3.sent;
              doc = _ref9.data;
              return _context3.abrupt('return', doc);

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, undefined);
    }));

    return function (_x2) {
      return _ref8.apply(this, arguments);
    };
  }();
};
var queryDocs = function queryDocs(_ref10) {
  var server = _ref10.server,
      view = _ref10.page.view;
  return function () {
    var _ref11 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(query) {
      var _ref12, docs;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return server.get({
                url: [API_PREFIX, view].join('/'),
                query: {
                  query: toArrayQuery((0, _omitBy2.default)(_isNil2.default)(query)),
                  sort: { '@@createdAt': -1 },
                  limit: 100,
                  populateall: true
                }
              });

            case 2:
              _ref12 = _context4.sent;
              docs = _ref12.data;
              return _context4.abrupt('return', docs);

            case 5:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, undefined);
    }));

    return function (_x3) {
      return _ref11.apply(this, arguments);
    };
  }();
};

// 根據 route 產生操作 storage 需要的 handlers
var shape = _propTypes2.default.shape,
    string = _propTypes2.default.string,
    object = _propTypes2.default.object;

var enhancer = (0, _composeWithScope2.default)((0, _getContext2.default)({
  server: object.isRequired
}), (0, _injectProps2.default)({
  page: shape({
    view: string.isRequired,
    docId: string
  })
}), (0, _exposeHandlers2.default)({
  findDoc: findDoc,
  insertDoc: insertDoc,
  updateDoc: updateDoc,
  queryDocs: queryDocs
}), (0, _exposeNamespace2.default)('db'));

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'provideStorage');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/enhancers/connectServer/provideStorage.js
// module id = 1163
// module chunks = 0